<div class="wealth-services-component">
    <div class="card wealth-services-component__tabs">
        <mb-tab-nav-bar [tabLinks]="tabLinks"></mb-tab-nav-bar>
    </div>
</div>
